module.exports = __webpack_public_path__ + "img/cgd2.c2c86b1d.jpg";